<template>
	<div class="box" style="height: 271px">
		<div class="padding h-100">
			<span class="refresh text-muted">
				<a @click="loadData" class="no-select btn-subtle" v-tippy title="Refresh">
					<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
				</a>
			</span>
			<table style="width: 100%; height: 100%; table-layout: fixed;">
				<tr style="height: 50%">
					<td class="text-center v-mid">
						<h1 :class="{ 'text-very-muted': !counts.teachers || busy }">{{ counts.teachers }}</h1>
						<h6 class="text-muted mb-0">Teachers</h6>
					</td>
					<td style="width: 1rem"></td>
					<td class="text-center v-mid">
						<h1 :class="{ 'text-very-muted': !counts.classes || busy }">{{ counts.classes }}</h1>
						<h6 class="text-muted mb-0">Classes</h6>
					</td>
				</tr>
				<tr style="height: 50%">
					<td class="text-center v-mid">
						<h1 :class="{ 'text-very-muted': !counts.schools || busy }">{{ counts.schools }}</h1>
						<h6 class="text-muted mb-0">Schools</h6>
					</td>
					<td style="width: 1rem"></td>
					<td class="text-center v-mid">
						<h1 :class="{ 'text-very-muted': !counts.districts || busy }">{{ counts.districts }}</h1>
						<h6 class="text-muted mb-0">Districts</h6>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<style scoped>
a {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a:hover {
	opacity: 1;
}
a > h1 {
	border-radius: 0.5rem;
	transition: background-color 0.25s;
	padding-bottom: 2px;
}
a > h1:hover {
	background-color: rgb(0, 0, 0, 0.05);
}
table {
	width: 100%;
}
td {
	padding: 0.25rem 0.5rem;
	text-overflow: ellipsis;
}
.refresh {
	position: absolute;
	top: 0.5rem;
	right: 1.5rem;
}
::-webkit-scrollbar {
	width: 7px;
}
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.2);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>

<script>
import ReportingService from "@/services/ReportingService";
import store from "@/services/Store";
import fs from "@/services/FormatService";
import chartjs from "chart.js";
require("@/directives/chartjs");
import moment from "moment";

export default {
	name: "TrafficDashCounts",

	props: ["team"],

	data() {
		return {
			fs: fs,
			busy: false,
			counts: {
				teachers: 0,
				classes: 0,
				districts: 0,
				schools: 0
			}
		};
	},
	created() {
		this.loadData();
	},
	watch: {
		"team.id"() {
			this.loadData();
		}
	},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			this.busy = true;
			ReportingService.getUsageCounts()
				.then(resp => {
					this.counts = resp.data;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.busy = false;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/TrafficDashboard/TrafficDashCounts.vue